module.exports = __webpack_public_path__ + "static/media/result-3.5cea3996.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/result-3.png
// module id = 144
// module chunks = 0